/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { css as cssUnbounded, jsx, keyframes } from '@compiled/react';

import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const shimmerAnimation = keyframes({
	'0%': {
		backgroundPosition: '200% 0',
	},
	'100%': {
		backgroundPosition: '-200% 0',
	},
});

const shimmerTextStyle = cssUnbounded({
	background: `linear-gradient(
		90deg,
		${token('color.text.subtlest')} 0%,
		${token('color.text.subtlest')} 20%,
		#C7CDDC 40%,
		${token('color.text.subtlest')} 60%,
		${token('color.text.subtlest')} 80%,
		#C7CDDC 90%,
		${token('color.text.subtlest')} 100%
	)`,
	backgroundSize: '200% 100%',
	WebkitBackgroundClip: 'text',
	WebkitTextFillColor: 'transparent',
	backgroundClip: 'text',
	animation: `${shimmerAnimation} 4s linear infinite`,
});

type ShimmerTextProps = {
	children: React.ReactNode;
	size?: 'small' | 'medium' | 'large';
	weight?: 'regular' | 'medium' | 'semibold';
};

export const ShimmerText = ({ children, size = 'medium', weight = 'regular' }: ShimmerTextProps) => {
	return (
		<div css={shimmerTextStyle}>
			<Text size={size} weight={weight} color="color.text.subtlest">
				{children}
			</Text>
		</div>
	);
};

